import apiClient from "./billingServiceClient";

export const fetchCustomerProfile = async () => {
  const response = await apiClient.get("/customer");
  return response.data;
};

export const updateCustomerProfile = async (payload = {}) => {
  const response = await apiClient.post("/customer", payload);
  return response.data;
};
